import {createSelector} from "reselect";

const dataExplorer = (state) => state.dataExplorer;

export const getDataExplorerTemplates = createSelector(
  dataExplorer,
  (dataExplorer) => dataExplorer.templates
);

export const getDataExplorerAnalysis = createSelector(
  dataExplorer,
  (dataExplorer) => dataExplorer.analysis || {}
);

export const getDataExplorerSensor = createSelector(
  dataExplorer,
  (dataExplorer) => dataExplorer.sensor
);

export const getDataExplorerTimezones = createSelector(
  dataExplorer,
  (dataExplorer) => dataExplorer.timezones || []
);

export const getDataExplorerSnapshots = createSelector(
  dataExplorer,
  (dataExplorer) => dataExplorer.snapshots || []
);
